
    <ul role="navigation">
      <li *ngFor="let node of nodes"><a class="nav-link" [href]="node.url" [title]="node.title">{{ node.title }}</a></li>
    </ul>


// WEBPACK FOOTER //
// /home/wzc/dev/angular/angular/aio/src/app/layout/top-menu/top-menu.component.ts.TopMenuComponent.html